import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  IListRequestParams,
  IMyKnownError,
  IPaginatedListResponse,
  REQUEST_LIFE_CICLE,
} from 'interfaces/requests';
import { MICROSERVICES, get } from 'api';
import endpoints from './endpoint';
import { IStrategyRegister } from 'components/StrategyRegister/interfaces';
import {
  clearDrillDownInterval,
  drillDownSimulationList,
  updateSimulationListByStrategyListAction,
} from 'modules/simulationList';

interface IStrategyNavigationModeState {
  loading: REQUEST_LIFE_CICLE;
  list: IStrategyRegister[];
  count: number;
}

const initialState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  list: [],
  count: 0,
} as IStrategyNavigationModeState;

export const listStrategyAction = createAsyncThunk<
  IPaginatedListResponse<IStrategyRegister>,
  IListRequestParams,
  { rejectValue: IMyKnownError }
>('strategy/list', async (payload, { rejectWithValue, dispatch }) => {
  try {
    const result = await get<IPaginatedListResponse<IStrategyRegister>>(
      MICROSERVICES.STRATEGIES,
      {
        url: endpoints.listStrategy(),
        params: {
          orderBy: 'updatedAt',
          orderDirection: 'desc',
          ...payload,
        },
      },
    );

    const strategyList = {
      count: result.data.count,
      values: result.data.values.map((str: IStrategyRegister) =>
        Object.assign(
          {},
          {
            ...str,
            id: str._id,
            simulationType: 'your_simulation_type',
            simulationStatus: 'your_simulation_status',
          },
        ),
      ),
    };

    await dispatch(
      updateSimulationListByStrategyListAction({
        strategyList: strategyList.values,
        strategyStatusListToRefresh: [
          'SIMULATING',
          // 'SIMULATION_READY',
          'ACTIVE',
          'ENDING',
        ],
      }),
    );

    dispatch(clearDrillDownInterval());
    // dispatch(drillDownSimulationList({}));

    return strategyList;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const strategyModeSlice = createSlice({
  name: 'strategy',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listStrategyAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(listStrategyAction.rejected, (state) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
      return state;
    });
    builder.addCase(listStrategyAction.fulfilled, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.list = action.payload.values;
      state.count = action.payload.count;
      return state;
    });
  },
});
const { reducer } = strategyModeSlice;
export default reducer;
